import React from "react";
import { useSelector } from "react-redux";
import EditIcon from "../icons/editIcon";
import Tooltip from "../General/tooltip";
import {checkIfQuestionAnswerUpdateRequiresARAGApproval} from "../../helpers/approvalSettings/functions";
import { shouldShowPigLockTooltip } from "../../helpers/pigLock";
import { INFO_TEXT_EDIT_WITH_APPROVAL, INFO_TEXT_EDIT_WITHOUT_APPROVAL, } from "../../helpers/variables";
import CONTENT_STRINGS from "../../helpers/contentStrings";
import {PRIMARY, TERTIARY} from "../../helpers/constants";

const QuestionEditActions = (props) => {
    const {
        question,
        mapEditingQuestionOrFieldToEditingSetting,
        approvalOptions,
        checkIfPlainEditable,
        onClick,
        hasPendingChanges,
    } = props;

    const userRoles = useSelector(state => state.user.loggedInUser.roles);
    const selectedApplication = useSelector(state => state.newApplication.selectedApplication);

    // WI 95280: the edit icon is hidden (checkIfQuestionIsEditable already returned false), so a tooltip
    // takes its place to explain why. Mutually exclusive with the EditIcon branch by construction.
    // Gated on the question actually having an editing setting, so a locked question that never had a pencil
    // (the Damages answers, reachable only via the LikelyClaimsTrack pencil) does not gain a stray icon.
    // Every call site passes mapEditingQuestionOrFieldToEditingSetting, so this is safe to call directly.
    const isPigLocked = shouldShowPigLockTooltip(
        question?.machineName,
        selectedApplication,
        mapEditingQuestionOrFieldToEditingSetting(question));

    // Determine if the question is editable and if it requires ARAG approval for edits
    // checkIfPlainEditable is checked because Medical Expert Fees table uses this component but the editing is done differently
    const requiresApproval = checkIfPlainEditable && checkIfQuestionAnswerUpdateRequiresARAGApproval(
        mapEditingQuestionOrFieldToEditingSetting(question),
        approvalOptions,
        userRoles
    );
    let variant = requiresApproval ? PRIMARY : TERTIARY;
    let informationText = requiresApproval ? INFO_TEXT_EDIT_WITH_APPROVAL : INFO_TEXT_EDIT_WITHOUT_APPROVAL;

    return (
        <div style={{display: "flex", justifyContent: "flex-end", alignItems: "center"}}>
            {
                hasPendingChanges 
                ?
                    <div className={"newApplication__awaiting-approval-wrapper pull-right"} style={{whiteSpace: 'nowrap'}} >
                        {CONTENT_STRINGS.AWAITING_APPROVAL}
                    </div>
                :
                    null
            }
            {
                checkIfPlainEditable
                ?
                    <EditIcon
                        variant={variant}
                        onClick={onClick}
                        informationText={informationText}
                        editIconTestId={`question-edit-actions-${question.id}`}
                    />
                :
                    null
            }
            {
                (!checkIfPlainEditable && isPigLocked)
                ?
                    // pig-lock-tooltip aligns the icon with the edit pencils on the rows above/below.
                    <div className="pig-lock-tooltip">
                        <Tooltip text={CONTENT_STRINGS.PIG_APPLIED_EDIT_LOCKED_TOOLTIP} />
                    </div>
                :
                    null
            }
        </div>
    )
};

export default QuestionEditActions;